import React from 'react';
import { useVisualMessage } from './VisualMessageContext';

const VisualMessageContainer = () => {
  const { messages, removeMessage } = useVisualMessage();

  const getMessageStyles = (type) => {
    const baseStyles = "transform transition-all duration-300 ease-in-out";
    
    switch (type) {
      case 'success':
        return `${baseStyles} bg-green-50 border border-green-200 text-green-800 shadow-lg shadow-green-100/50 message-section`;
      case 'error':
        return `${baseStyles} bg-red-50 border border-red-200 text-red-800 shadow-lg shadow-red-100/50 message-section`;
      case 'warning':
        return `${baseStyles} bg-amber-50 border border-amber-200 text-amber-800 shadow-lg shadow-amber-100/50 message-section`;
      case 'info':
        return `${baseStyles} bg-blue-50 border border-blue-200 text-blue-800 shadow-lg shadow-blue-100/50 message-section`;
      default:
        return `${baseStyles} bg-gray-50 border border-gray-200 text-gray-800 shadow-lg shadow-gray-100/50 message-section`;
    }
  };

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return (
          <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        );
      case 'error':
        return null; // Remove the error X icon
      case 'warning':
        return (
          <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.314 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        );
      case 'info':
        return (
          <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
      default:
        return null;
    }
  };

  if (messages.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-[9999] space-y-3 max-w-sm w-full pointer-events-none">
      {messages.map((message) => (
        <div
          key={message.id}
          className={`${getMessageStyles(message.type)} 
            rounded-2xl p-4 backdrop-blur-sm bg-opacity-95 
            animate-in slide-in-from-right-5 fade-in 
            pointer-events-auto max-w-sm w-full
            hover:shadow-xl transition-shadow duration-200`}
        >
          <div className="flex items-start space-x-3">
            {getIcon(message.type) && (
              <div className="flex-shrink-0 mt-0.5">
                {getIcon(message.type)}
              </div>
            )}
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium leading-5 break-words">
                {message.text}
              </p>
            </div>
            <button
              onClick={() => removeMessage(message.id)}
              className="flex-shrink-0 ml-2 opacity-60 hover:opacity-100 transition-opacity duration-200"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VisualMessageContainer;